import {BaseQuestion} from "pages/Test/components/question/Question";
import {AppFlex} from "shared/UI/UIKit/Flex";
import type {Question} from "../../../config/types";

type TestProps = {
  questions: Question[]
}

export const Test = (props: TestProps) => {
  return (
    <AppFlex unit="40">
      {
        props.questions.map(item => {
          return <BaseQuestion question={item} key={item.id}/>;
        })
      }
    </AppFlex>
  );
};